import { Component, DoCheck, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Block } from '@app/core/models/block/block.model';
import { FilterData } from '@app/core/services/api/api-filter.service';
import { findFirstBySettingsKey } from '@app/shared/helpers/block-helpers';
import { FilterType } from '@core/models';

@Component({
  selector: 'filter-select-item',
  styleUrls: ['./filter-group-selector.component.scss'],
  template: `
    <div class="filter-select-item" [formGroup]="form">

      <label>
        <div [class]="template.uId"
             [attr.data-c-id]="_uid"
             [filterActive]="isActive">
          <div
            app-block
            *ngFor="let block of template.children"
            [class]="block.uId"
            [filterActive]="isActive"
            [item]="block"
            [attr.tabindex]="block.tabindex"
          ></div>
        </div>
        <input type="checkbox" (change)="onCheckedChanged()"/>
      </label>
    </div>
  `,
  standalone: false,
})
export class FilterSelectItemComponent implements OnChanges, DoCheck {


  @Input() form: FormGroup;
  @Input() item: FilterData;
  @Input() controlType: FilterType;
  @Input() template: Block;
  @Output() checked = new EventEmitter<any>();

  get isActive(): boolean {
    return this.form.get('active').value;
  }

  get _uid(): string {
    return this.template.uId;
  }

  ngDoCheck(): void {
    if (this.item['active'] && this.item['active'] != this.form.get('active').value) {
      this.form.patchValue({active: this.item['active']});
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.item && this.template) {
      const headerBlock = findFirstBySettingsKey(
        this.template,
        'viewPart',
        'categoryHeader',
      );
      // update category name;
      headerBlock.content = this.item.name;
    }
  }

  onCheckedChanged() {
    const _active = !this.isActive;
    this.form.patchValue({active: _active});
    this.checked.emit(this.form.value);
  }
}
